// extracted by mini-css-extract-plugin
module.exports = {"bgImg":"layoutLogin_bgImg__cjYC9"};